import { useThorEvent } from "@aviv-dxp/react-thor";
import { useTrackingEventsDatas } from "./useTracking";
export const useTrackingCallbackAnswered = (av_zone) => {
    const EVENT_DATA = {
        event: "request_callback_contact_success",
        av_zone,
        ...useTrackingEventsDatas({
            displayMedium: true,
            conversionType: "phone",
        }),
    };
    return useThorEvent({
        compatibilities: { GA3: false, GA4: true },
        // @ts-expect-error no request_callback_contact_success event in ga interface
        eventData: EVENT_DATA,
    });
};
